<template>
  <div
    v-if="showBanner"
    class="relative mb-10 banner-custom-height"
    
  >
    <div v-if="bannerType === 3" :style="[customCss]" class="banner-center h-full">
      <div class="absolute w-full h-full banner-image-wrapper">
        <slot name="avatar"></slot>
      </div>
      <div class="absolute w-full h-full z-10 banner-overlay-color"></div>
      <div class="absolute w-full h-full flex items-center justify-center z-11 banner-text-wrapper">
        <div class="membership-layout-container w-full">
          <slot name="story"></slot>
        </div>
      </div>
    </div>


    <div v-else-if="bannerType === 2" class="h-full banner-right">
      <div class="w-full h-full flex">
        <div class="w-1/2 banner-image-wrapper">
          <slot name="avatar"></slot>
          
        </div>
        <div :style="[customCss]" class="relative w-1/2 banner-text-wrapper">
          <div class="absolute w-full h-full z-10 banner-overlay-color"></div>
          <div class="absolute banner-gradiant text-black w-full h-full z-11 px-3" >
            <div class="membership-layout-container" >
              <div class="text-left">
                <slot name="story"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-else class="h-full banner-left">
      <div class="w-full h-full flex">
        <div :style="[customCss]" class="relative w-1/2 banner-text-wrapper">
          <div class="absolute w-full h-full z-10 banner-overlay-color"></div>
          <div class="absolute banner-gradiant text-black w-full z-11 px-3">
            
            <div class="membership-layout-container">
              <div class="text-left">
                <slot name="story"></slot>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/2 banner-image-wrapper">
          
          <slot name="avatar"></slot>
        </div>
      </div>
    </div>




  </div>
  <div v-else class="pb-10"></div>
</template>
<script>
export default {
  name: 'Hero',
  props: {
    overlayColor: {},
    showBanner: {},
    bannerType: {},
  },
  computed: {
    customCss() {
      return {
        '--banner-overlay-color': this.overlayColor,
      };
    },
  },
};
</script>
<style lang="scss">
.banner-overlay-color {
  background: var(--banner-overlay-color);
}
.banner-custom-height {
  height: 27rem;
  .z-11 {
    z-index: 11;
  }
  .featured-section{
    height: 27rem;
  }
}
.banner-left{
  .custom-banner-image-overlay{
  left:-6%;
  z-index: 12;
  position: absolute;
  bottom: 9px;
}
}
.banner-right{
  .custom-banner-image-overlay{
  right:-98%;
  z-index: 12;
  position: absolute;
  bottom: 9px;
}
}
.banner-center{
  .custom-banner-image-overlay{
    bottom: 15px;
    right: 100px;
    position: absolute;
    z-index: 12;
  }

}
.banner-right, .banner-left{
  .custom-banner-image-overlay{
    .image-overlay-text{
      color:transparent;
      &:before{
        content: 'Choose Color';
        color: #fff;
        position: absolute;
      }
    }
  }
}

.tablet-template{
  .banner-custom-height {
    height: 320px;
    .featured-section{
    height: 320px !important;
    }
  }
}
.mobile-template {
  .banner-custom-height {
    height:363px !important;
    margin-bottom: 25px;
    .banner-left, .banner-right{
      .w-1\/2{
        width: 100%;
      }
      .flex{
        flex-direction: column;
      }
      .banner-gradiant{
        position: relative;
      }
      .banner-text-wrapper{
        height:100%
      }
      .banner-image-wrapper{
        margin: auto;
        bottom: 23px;
        z-index: 11;
        position: absolute;
        width: 80%;
        left: 0px;
        right: 0px;
      }
    }
    .banner-center{
      .membership-banner-container{
        height:363px;
      }
      .banner-image-wrapper{
        margin: auto;
        top: 0px;
        z-index: 10;
        position: absolute;
        width: 100%;
        left: 0px;
        right: 0px;
        height:363px;
        .featured-section{
          height: 363px !important;
        }
      }
      .banner-text-wrapper{
        position: relative;
        align-items: flex-start;
      }
    }
  }
}

@media only screen and (max-width:767px){
  .banner-custom-height {
    height:363px !important;
    margin-bottom: 25px;
    .banner-left, .banner-right{
      .w-1\/2{
        width: 100%;
      }
      .flex{
        flex-direction: column;
      }
      .banner-gradiant{
        position: relative;
      }
      .banner-text-wrapper{
        height:100%
      }
      .banner-image-wrapper{
        margin: auto;
        bottom: 23px;
        z-index: 11;
        position: absolute;
        width: 80%;
        left: 0px;
        right: 0px;
      }
    }
    .banner-center{
      .membership-banner-container{
        height:363px;
      }
      .banner-image-wrapper{
        margin: auto;
        top: 0px;
        z-index: 10;
        position: absolute;
        width: 100%;
        left: 0px;
        right: 0px;
        height:363px;
        .featured-section{
          height: 363px !important;
        }
      }
      .banner-text-wrapper{
        position: relative;
        align-items: flex-start;
      }
    }
  }
}
</style>